import React, { Fragment, useState } from 'react'
import '../../../../assets/css/pantalla1.css'
import '../../../../assets/css/analiticaCards.css'
import { Row, Col, Label} from 'reactstrap';
import { useSend } from '../../../../hooks/send/useSend';
import { ModalSendSamplings } from './ModalSendSamplings';
import DeniReactTreeView from "deni-react-treeview"
import 'animate.css';
import { Card } from 'primereact/card';
import { Avatar } from 'primereact/avatar';
import avatarHombre from '../../../../assets/images/user/hombre.png';
import avatarMujer from '../../../../assets/images/user/mujer.png';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { InputText } from "primereact/inputtext";
import { Toast } from 'primereact/toast';
import { Button } from 'primereact/button';


export const IndexSend = () => {

    const {
        // * MODAL AND KEYS NIM
        typeSend, modalSend, openModal, closeModal, handleSendSample, nimAutoFocus, onKeyPressNim, getDataNim,
        handleSelectValuesNim, nim, handleInputChangeNim,loading,

        // * EXAM AND PROFILES
        treeviewRef, itemsTree, listNims,varSample,changeTree, saveSendSample,viewExams,
   
        // * NEW METHODS
        dataPatient,loadingView,loadindSend,nameBranch,showConfirmationToast,toastBC,
        focusNimEnabled,

        // * SEARCH TABLE PATIENT
        handleInfo,loadingInfor,customBody,
        globalFilter,setGlobalFilter,validSearch, setValidSearch,viewInfo,customBodyEstatus,
        

    } = useSend();


    // ? CONFIGURATION CARDS INFO
     const onRenderItem = (_find) => {
        return (
            <div className="treeview-item-example">
                {
                    _find.state === 1 && _find.check_forwarded === false ?
                        <span style={{color:"#51bb25"}} >
                            <i className="icofont icofont-laboratory f-12"></i>{_find.text}&nbsp;
                                {
                                    _find.is_send1 === true ? <i className='fa fa-check txt-success f-18' ></i> : <i className='fa fa-times text-danger f-16' ></i>
                                       
                                }&nbsp;
                                {
                                    _find.is_send2 === true ? <i className='fa fa-check txt-success f-18' ></i> :<i className='fa fa-times text-danger f-16' ></i>
                                      
                                }&nbsp;
                                
                            </span>
                            :
                    _find.state === 1 && _find.check_forwarded === true ?
                        <span>
                            <i className="icofont icofont-laboratory f-12"></i>{_find.text}&nbsp;
                                {
                                    _find.is_send1 === true ? <i className='fa fa-check txt-success f-18' ></i> : <i className='fa fa-times text-danger f-16' ></i> 
                                           
                                }&nbsp;
                                {
                                    _find.is_send2 === true ? <i className='fa fa-check txt-success f-18' ></i> :<i className='fa fa-times text-danger f-16' ></i>         
                                }&nbsp;
                                </span>
                                : 
                        <span style={{ color: '#FF8F00' }}>
                            <i style={{ color: '#FF8F00' }} className="icofont icofont-laboratory f-12"></i>{_find.text}&nbsp;
                                {
                                    _find.valueDontSend === 1 ? <i className='icofont icofont-ui-block text-danger f-16' ></i> :
                                    _find.valueDontSend === 2 ? <i className='icofont icofont-ui-clock text-danger f-16' > </i> :
                                    <i className="icofont icofont-ui-block text-danger f-12"></i>
                                }&nbsp;
                        </span>
                }
            </div>
        )
    }

    const titlePatient = <>
    {
        dataPatient.length > 0 && dataPatient.map((_patient, index) => {
            const avatarImage = _patient?.gender === 2 ? avatarHombre : avatarMujer;
            return (
                <Col key={index} sm="12">
                    <Col sm="12" >
                    <Row>
                        <Col sm="10">
                         <ul className="list-group" style={{display:'-webkit-box', width:'100%'}}>
                            <li style={{fontSize:"12px", maxWidth: "150px"}} className="list-group-item list-group-item-success rounded-lg text-center font-weight-bold px-4">Con muestra</li>
                            <li style={{fontSize:"12px", maxWidth: "150px"}} className="list-group-item list-group-item-primary rounded-lg text-center font-weight-bold px-4">Remitida</li>
                            <li style={{fontSize:"12px", maxWidth: "150px", backgroundColor: '#ff8f00a6'}} className="list-group-item list-group-item rounded-lg text-center font-weight-bold px-4">Sin muestra</li>
                        </ul>
                        </Col>
                        <Col sm="2" style={{textAlign:"right"}}>
                        <Button style={{backgroundColor:"#fff", color:"#082d9d"}}  label="Regresar" icon="pi pi-users"  onClick={showConfirmationToast} severity="warning"  />
                        <Toast ref={toastBC} position="center" />
                        </Col>
                    </Row>
                    </Col>
                    <Avatar image={avatarImage} size="xlarge" shape="circle" />
                    <Row>
                        <Col sm="3">
                        <label style={{fontSize:"12px"}} >Nombre <br /> {_patient?.name_patient ?? "---"} </label>
                        </Col>
                       <Col sm="3">
                        <label style={{fontSize:"12px"}} >Nim <br /> {_patient?.nim  ?? "---"} </label>
                        </Col>
                         <Col sm="3">
                        <label style={{fontSize:"12px"}} >Edad <br /> {_patient?.age ?? "---"} </label>
                        </Col>
                      <Col sm="3">
                        <label style={{fontSize:"12px"}} >Fecha de ingreso <br /> {_patient?.admision_date ?? "---"} </label>
                        </Col>
                    </Row>
                </Col>
            );
        })
    }
     </>;


    return (
        <Fragment  >
            <div >

                <Col xs="12" sm="12" md="12" lg="12" xl="12" className="">
                    <Row>
                        <Col xs="12" sm="12" md="12" lg="12" xl="12" className=" p-l-0 p-r-0"> <br />
                            <div className='box-departamento-send'>
                                <Col sm="12" style={{ textAlign: "-webkit-center" }}>
                                    <Row>
                                        <Col xs="2" sm="2" md="2" lg="2" xl="2" className='p-l-0'>
                                            <Label className='labelToma1'></Label>
                                        </Col>
                                        <Col xs="9" sm="9" md="9" lg="9" xl="9">
                                            <label className='labelToma1'>
                                                {
                                                    varSample === false ? "Recibir Muestras" : "Envio de Muestras"
                                                }
                                            </label>
                                        </Col>
                                    </Row>
                                </Col>
                            </div>
                        </Col>
                    </Row>
                </Col>
                
                <Col xs="12" sm="12" md="12" lg="12" xl="12">
                    <Row>
                        <Col sm="12" md="5" lg="4" className='pt-0' >
                        <Card className='pt-0 pr-0' >
                            <Col sm="12" className='p-l-0 p-r-0'>
                             <Row>
                                <Col sm="10" className='p-r-0 p-l-0' >
                                    {
                                    varSample === false ? 
                                        <label style={{fontSize:"13px"}} className='txt-info f-w-600' >Trabajo recibido en la sucursal <b style={{color:"#1f4e69",fontSize:"13px"}} >  {nameBranch} </b> </label>
                                        :
                                        <label style={{fontSize:"13px"}} className='txt-info f-w-600' >Trabajo enviado de la sucursal <b style={{color:"#1f4e69",fontSize:"13px"}} >  {nameBranch} </b> </label>
                                    }
                                </Col>
                                <Col sm="1" className='p-l-0 pb-3'>
                                 <Button 
                                    icon={validSearch ? "pi pi-times" : "pi pi-search"} 
                                    rounded 
                                    severity={validSearch ? "danger" : "success"} 
                                    aria-label="Search" 
                                    onClick={() => setValidSearch(!validSearch)}
                                    style={{
                                        padding: "5px 10px",
                                        height: "35px",
                                        width: "35px",
                                        fontSize: "1rem",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center"
                                    }}
                                />
                                </Col>
                            </Row>
                            <Col sm="12" className='p-l-0 p-r-0'>
                                <DataTable
                                    className="data-table"
                                    globalFilter={globalFilter}
                                    value={listNims}
                                    paginator
                                    rows={6}
                                    responsiveLayout="scroll"
                                    emptyMessage="No hay resultados disponibles."
                                    rowsPerPageOptions={[6,12, 20, 30, 40 ,50]}
                                    header={
                                        <Col sm="12" className={validSearch ? "p-l-0" : "d-none"} >
                                        <span className="p-input-icon-left">
                                            <i className="pi pi-search" />
                                            <InputText
                                                type="search"
                                                className="pl-6"
                                                onInput={(e) => setGlobalFilter(e.target.value)}
                                                style={{ width: "auto" }}
                                            />
                                        </span>
                                        </Col>
                                    }
                                >
                                    <Column
                                        field="nim"
                                        header="Nim"
                                        sortable
                                        headerStyle={{
                                            backgroundColor: "#1d5b83",
                                            color: "#fff",
                                            fontWeight: "bold",
                                            fontSize: "10px",
                                            padding: "2px",
                                        }}
                                        style={{
                                            fontSize: "10px",
                                            textAlign: "center",
                                            width: "10%",
                                        }}
                                        body={customBody} 
                                    />
                                     <Column
                                        field="complete"
                                        header="Estatus"
                                        sortable
                                        headerStyle={{
                                            backgroundColor: "#1d5b83",
                                            color: "#fff",
                                            fontWeight: "bold",
                                            fontSize: "10px",
                                            padding: "2px",
                                        }}
                                        style={{
                                            fontSize: "10px",
                                            textAlign: "center",
                                            width: "10%",
                                        }}
                                        body={customBodyEstatus} 
                                    />
                                    <Column
                                        field="created_at"
                                        header="Fecha de ingreso"
                                        sortable
                                        headerStyle={{
                                            backgroundColor: "#1d5b83",
                                            color: "#fff",
                                            fontWeight: "bold",
                                            fontSize: "10px",
                                            padding: "2px",
                                        }}
                                        style={{
                                            fontSize: "10px",
                                            textAlign: "center",
                                            width: "10%",
                                        }}
                                    />
                                    <Column
                                        header="Acciones"
                                        body={(rowData) => (
                                        <div className="d-flex justify-content-center">
                                            <button
                                                className="p-button p-button-success p-button-sm"
                                                onClick={() => handleInfo(rowData.nim)}
                                                title="Información"
                                                style={{
                                                    border: "none",
                                                    background: "transparent",
                                                    cursor: "pointer",
                                                    width: "50px",
                                                }}
                                            >
                                             {loadingInfor === rowData.nim ? (
                                                <i className="pi pi-spin pi-spinner" style={{ fontSize: "1.2rem", color: "green" }}></i>
                                            ) : (
                                                <i className="pi pi-search" style={{ fontSize: "1.2rem", color: "green" }}></i>
                                            )}
                                            </button>                                                                                 
                                        </div>
                                            )}
                                                headerStyle={{
                                                    backgroundColor: "#1d5b83",
                                                    color: "#fff",
                                                    fontWeight: "bold",
                                                    fontSize: "10px",
                                                    padding: "2px",
                                                    textAlign: "center",
                                                }}
                                                style={{
                                                    textAlign: "center",
                                                    width: "10%",  
                                                }}
                                    />
                                </DataTable>
                            </Col>    
                            </Col>
                        </Card>  
                        </Col>
                        <Col sm="12" md="7" lg="8" style={{ textAlign: "center" }} className='p-r-0 p-l-0 pt-0' >
                            <div   style={{
                            position: 'absolute',
                            left: '-9999px',
                            top: '-9999px',
                            width: '1px',
                            height: '1px',
                            overflow: 'hidden',
                            zIndex: -1
                        }} className= {  validSearch ? "d-none" : "ocultar-input pt-0"}	>
                                <input
                                    id='inputFocusNim'
                                    autoFocus={focusNimEnabled}
                                    value={nim}
                                    onChange={(e) => handleSelectValuesNim(e.target.value, "nim")}
                                    onKeyDown={onKeyPressNim}
                                    onBlur={nimAutoFocus}
                                />
                            </div>
                            <Col sm="12" className={!viewExams ? "pt-0" : "d-none"}>
                                <div style={{ zIndex: 1 }}>
                                    <img className="" src={require("../../../../assetsToma/imagenes/Barras.gif")} style={{ width: "38%" }} alt="" />
                                </div>
                                <div className='a-line'>
                                    <label className='labelIniciarMuestra'>Escanea el <b className=''>Código de barras </b> de las muestras</label> <br />
                                </div>
                                <label className='labelCode'>o</label> <br />
                                <button className='bottonIniciarMuestra' style={{ backgroundColor: "#1f4e69" }} onClick={handleSendSample} > Ingresálo manualmente</button> <br /><br /><br />
                            </Col>
                            <Col xs="12" sm="12" md="12" lg="12" xl="12" className={viewExams === true ? "pt-0 pl-0 " : "d-none pt-0"} >
                            <Card   title={titlePatient} subTitle="Estudios a realizar"  className={loadingView ? "md:w-25rem pt-0 pl-0 " : false } >
                                <Col sm="12" className='pl-0 pr-0' >
                                <Row className='pl-0 p-r-0' >
                                    <Col sm="2">
                                    </Col>
                                    <Col sm="9">
                                    <DeniReactTreeView
                                        ref={treeviewRef}
                                        //showCheckbox={ loadindSend ?  false : true}
                                        showCheckbox={ false}
                                        style={{ 
                                            marginRight: '10px', 
                                            marginBottom: '10px', 
                                            height: "200px", 
                                            width: "100%", 
                                            textAlign: "center",
                                            border: "2px solid #1f4e69", 
                                            borderRadius: "10px" 
                                        }}
                                        showIcon={false}
                                        items={itemsTree}
                                        selectRow={false}
                                        onRenderItem={onRenderItem}
                                        onCheckItem={(e) => changeTree(e)}

                                        className="deni-react-treeview-container.green .deni-react-treeview-item-container.green .icon-and-text.selected"
                                    />
                                    <br />
                                    <Button className={ !viewInfo ? "d-none" : loadindSend ? "d-none" : ""} outline color='primary' size='sm' onClick={() => saveSendSample()} >Aceptar</Button>
                                    </Col>
                                </Row>
                                </Col>
                        </Card>
                            </Col>
                        </Col>
                    </Row>
                </Col>
            <ModalSendSamplings
                {
                ...{
                    typeSend, modalSend, openModal, closeModal, getDataNim, handleSelectValuesNim, nim, handleInputChangeNim, loading
                }
                }
            />
        </div>  
        </Fragment >
    )
}
